function setLoadOut(data) {
	return {
		type: 'SET_LOAD_OUT',
		payload: data,
	};
}

export { setLoadOut };
